<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>PHÂN CÔNG GIÁM THỊ</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-select
            :items="exams"
            v-model="exam"
            label="Chọn kỳ thi"
            item-value="id"
            item-text="name"
            :rules="[$rules.required]"
            return-object
            outlined
            @change="examSelected"
          ></v-select>
          <v-row>
            <v-col cols="6">
              <v-select
                :items="rooms"
                v-model="room"
                label="Chọn phòng thi"
                item-value="id"
                item-text="name"
                return-object
                outlined
                :rules="[$rules.required]"
                @change="roomSelected"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="filteredSubjects"
                v-model="subject"
                label="Chọn môn thi"
                item-value="id"
                item-text="name"
                return-object
                :rules="[$rules.required]"
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <AutocompleteTeacherCard
            :syncedValue.sync="teacher"
            item-text="name"
            clear-icon="mdi-close"
            label="Giáo viên"
            outlined
            deletable-chips
            :rules="[$rules.required]"
            :displaySubjectGroup="true"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import { RoomSubject } from '../../plugins/api'

export default {
  props: {
    state: Boolean
  },
  components: {
    AutocompleteTeacherCard
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  async mounted() {
    await this.getExams()
  },
  data() {
    return {
      dialog: false,
      loading: false,
      exam: '',
      teacher: null,
      room: '',
      subject: '',
      exams: [],
      subjects: [],
      rooms: [],
      filteredSubjects: [],
      teachers: []
    }
  },
  methods: {
    ...mapActions('monitor', ['createMonitorExam']),
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('room', ['fetchRooms']),
    ...mapActions('exam', ['fetchExams']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        let data = {
          monitor: this.teacher.id,
          exam: this.exam.id,
          room: this.room.id,
          subject: this.subject.id
        }
        const createProd = await RoomSubject.assignMonitor({ ...data })

        if (createProd) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Lỗi phân công')
        }
        this.$loading.active = false
      }
    },
    resetForm() {
      this.teacher = null
      this.exam = ''
      this.room = ''
      this.subject = ''
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active' })
      this.$loading.active = false
    },

    async getRooms(query) {
      this.rooms = await this.fetchRooms(query)
    },
    async getSubjects(query) {
      this.subjects = await this.fetchSubjects(query)
    },
    async examSelected() {
      this.$loading.active = true
      await this.getSubjects({ exam: this.exam ? this.exam.id : '' })
      await this.getRooms({ exam: this.exam ? this.exam.id : '', _limit: -1 })
      this.room = ''
      this.$loading.active = false
    },
    async roomSelected() {
      this.$loading.active = true
      if (this.room && this.room.subjects) {
        this.filteredSubjects = this.subjects.filter(subject =>
          this.room.subjects.some(roomSubject => roomSubject.id === subject.id)
        )
      }
      this.$loading.active = false
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
